"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Popup = _interopRequireDefault(require("./Popup"));

exports.default = _Popup.default;